// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3oBFn","fileBtn":"File_fileBtn__2OmVu","closeBtn":"File_closeBtn__2PMvf","fileSelected":"File_fileSelected__3og06","disabled":"File_disabled__2Wtvc"};